import { useEffect } from 'react'
import { setCookie, getCookie } from '../../logging/cookie'

const AWC_STORAGE_KEY = 'awc'

/**
 * Get stored AWC from localStorage or cookie
 */
export function getStoredAwc(): string | null {
  // Try localStorage first
  try {
    const awcFromStorage = localStorage.getItem(AWC_STORAGE_KEY)
    if (awcFromStorage) {
      return awcFromStorage
    }
  } catch (e) {
    console.error('Failed to read AWC from localStorage:', e)
  }

  // Fall back to cookie
  const awcFromCookie = getCookie(AWC_STORAGE_KEY)
  return awcFromCookie || null
}

/**
 * Hook to get the "awc" URL parameter, store it in localStorage and cookie
 */
export function useAwc() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const awcParam = urlParams.get('awc')
    console.log('awcParam', awcParam)
    if (awcParam) {
      // Save to localStorage
      try {
        localStorage.setItem(AWC_STORAGE_KEY, awcParam)
      } catch (e) {
        console.error('Failed to save AWC to localStorage:', e)
      }

      // Save to cookie for 365 days
      setCookie('awc', awcParam, 365, 'Lax', false)
    }
  }, [])
}
